module.exports = __webpack_public_path__ + "static/media/logo-blue.f2ddbb90.png";